
import logo from './logo1.svg';
import './App.css';
import screenshot from './main.png'
import React, { useEffect } from "react";
import featureShot from './dry-food.png'
import appstore from './apstore.svg'
import {Link} from 'react-router-dom'
import google from './googleplay.svg'


const Home = () => {
  useEffect(() => {
    const sections = document.querySelectorAll(".fade-in");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.1 }
    );

    sections.forEach((section) => observer.observe(section));

    return () => observer.disconnect();
  }, []);

    return (
      <div className="landing-page">
      <div className="glass-card fade-in">
        {/* Hero Section */}
        <section className="hero">
          <div className="container">
            <div className="branding horizontal">
            <img src={logo} alt="PawPlate Logo" className="logo animate-logo" />
              <h1 className="brand-name">PawPlate</h1>
        
            </div>
            <h1 className="hero-title">Smarter Feeding. Healthier Dogs.</h1>
            <p className="hero-subtitle">Track calories, log meals, and help your dog lose weight the smart way.</p>
            <div className="hero-buttons">
             <img src={appstore} alt="appstore" className="primary-btn"/>
             <Link to='/android'><img src={google} alt="google play" className='primary-btn'/></Link>
            </div>
            
          </div>
        </section>
        <section className="preview-about fade-in">
  <div className="container preview-about-inner">
    <div className="mobile-preview">
      <div className="phone-frame">
        <img src={screenshot} alt="App preview" />
      </div>
    </div>
    <div className="about-block">
      <h2 className="section-heading">About Us</h2>
      <p className="about-text">
        At PawPlate, we help your dog lose weight the smart way — using personalized nutrition
        and meal tracking based on global veterinary standards. Your pet deserves a healthier, happier life.
      </p>
    </div>
  </div>
</section>

        

      <section className="features fade-in">
          <div className="container features-inner">
            <div className="features-text">
              <h2>Why PawPlate?</h2>
              <ul>
                <li><span className="emoji">✅</span> Tailored calorie recommendations</li>
                <li><span className="emoji">✅</span> Food logging for kibble, raw & human food</li>
                <li><span className="emoji">✅</span> Visual weight tracking & BCS analytics</li>
                <li><span className="emoji">✅</span> Reminders & feeding insights</li>
                <li><span className="emoji">✅</span> Designed for overweight dogs</li>
              </ul>
            </div>
            <div className="mobile-preview">
      <div className="phone-frame">
            <div className="feature-screenshot">
              <img src={featureShot} alt="Feature screenshot" />
            </div>
            </div>
            </div>
          </div>
        </section>

        {/* How It Works */}
        <section className="how-it-works fade-in">
          <div className="container">
            <h2 className="section-heading how">How It Works</h2>
            <div className="steps">
              <div className="step">
              <div className="step-icon-circle">1</div>
                <h3>Create your dog’s profile</h3>
                <p className="step-description">Tell us about your dog’s breed, weight and body condition to get a personalized plan.</p>
              </div>
              <div className="step">
              <div className="step-icon-circle">2</div>
                <h3>Log meals in seconds</h3>
                <p className="step-description">Easily add kibble, raw or human food. We calculate calories and nutrients automatically.</p>
              </div>
              <div className="step">
              <div className="step-icon-circle">3</div>
                <h3>Track weight & progress</h3>
                <p className="step-description">Visualize your dog’s improvement over time with progress charts and reminders.</p>
              </div>
            </div>
          </div>
        </section>


        {/* Footer */}
        <footer className="footer fade-in">
          <div className="container">
            <p>© 2025 Opami LLC. All rights reserved.</p>
          </div>
          <div className="footer-links">
              <Link to="/privacy-policy">Privacy Policy</Link>
              <Link to="/terms-of-use">Terms of Use</Link>
              <Link to="/subscription-policy">Subscription Policy</Link>
              <Link to="/contact-us">Contact Us</Link>

            </div>
        </footer>
      </div>
    </div>
    );
  }
  
  export default Home;
  